export default __webpack_public_path__ + "73bf96b45c02d6f927c239c7ac9cf567.svg";